// 仅用于本机开发服务器的页面和菜单权限调试。
export function isLocalPermissionBypassEnabled() {
    return process.env.VUE_APP_LOCAL_PERMISSION_BYPASS === 'true'
        && ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
}
